//Libreria google pay cargada VTCARTFORM

export async function bookingGooglePay(cart, data, merchantURL, debug=false){

  let paymentsClient = null;
  let g_amount=0.0;

  function setGoogleAmount(amount) {
    g_amount=parseFloat(amount);
  }

  function getGoogleAmount() {
    return g_amount;
  }

  function getGooglePaymentDataRequest() {
    const paymentDataRequest = {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            allowedCardNetworks: ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"],//["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"]
            billingAddressRequired: true,
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: 'redsys',
              gatewayMerchantId: '154059737',
            },
          },
        },
      ],
      merchantInfo: {
        merchantId: 'BCR2DN4T5T77ZOY2',
        merchantName: 'Viajes Teide',
        merchantOrigin: 'viajesteide.es'
      },
      transactionInfo: {
        countryCode: 'ES',
        currencyCode: 'EUR',
        totalPriceStatus: 'FINAL',
        //totalPriceLabel: 'Total',
        totalPrice: getGoogleAmount().toFixed(2),
        checkoutOption: 'COMPLETE_IMMEDIATE_PURCHASE',
        /*displayItems: [
          {
              label: "Subtotal",
              type: "SUBTOTAL",
              price: "11.00",
          },
          {
              label: "Tax",
              type: "TAX",
              price: "1.00",
          },
          {
              "label": "Shipping",
              "type": "LINE_ITEM",
              "price": "0", // Won't be displayed since status is PENDING
              "status": "PENDING",
          }
      ]*/
      },
    }

    return paymentDataRequest;
  }

  function getGooglePaymentsClient() {
    if ( paymentsClient === null ) {
      paymentsClient = new google.payments.api.PaymentsClient({environment: process.env.GOOGLE_PAY_ENVIRONMENT}); //{environment: 'TEST'} {environment: 'PRODUCTION'}
    }
    return paymentsClient;
  }

  if (debug) console.log("[VTCartForm]-> PAYMENT GOOGLE PAY");
  if (debug) console.log("cart",cart);
  if (debug) console.log("data",data);
  if (debug) console.log("merchantURL",merchantURL);
  if (debug) console.log("URL",process.env.API_URL+"bookingGooglePay");
  if (debug) console.log("process.env.GOOGLE_PAY_ENVIRONMENT",process.env.GOOGLE_PAY_ENVIRONMENT);

  setGoogleAmount(data.amount-data.promotion);
  paymentsClient = getGooglePaymentsClient();
  const paymentData= await paymentsClient.loadPaymentData(getGooglePaymentDataRequest());
  const paymentToken = btoa(paymentData.paymentMethodData.tokenizationData.token);

  const postdata = new FormData();
  postdata.append('cartcontent',JSON.stringify(cart));
  postdata.append('formdata',JSON.stringify(data));
  postdata.append('merchantURL',JSON.stringify(merchantURL));
  postdata.append('paymentToken',JSON.stringify(paymentToken));

  try {
    const response = await fetch(process.env.API_URL+"bookingGooglePay",{
      method: 'POST',
      body: postdata
    });

    if (!response.ok) {
      return {error:2203, data:''};
    }

    const jsonresponse = await response.json();
    if (!jsonresponse.success) {
      return {error:jsonresponse.error, data:'', debug:jsonresponse.debug}
    }

    return {error:0, data:jsonresponse.data, debug:jsonresponse.debug}

  } catch (error) {
    console.error(error);
    return {error:2203, data:''}
  }
}


